import * as crypto from 'node:crypto';

export class HashOperation
{
    static SHA256<T>(message: T): string
    {
        const hash = crypto.createHash('sha256');
        hash.update(JSON.stringify(message));
        return hash.digest('hex');
    }
    static SHA256Secret<T>(secret: string, message: T): string
    {
        const hash = crypto.createHmac('sha256', secret);
        hash.update(JSON.stringify(message));
        return hash.digest('hex');
    }
    static isValidSHA256(values: any, signature: string)
    {
        return this.SHA256(values).toLowerCase() === signature.toLowerCase();
    }
    static isValidSHA256Secret(secret: string, values: any, signature: string)
    {
        return this.SHA256Secret(secret, values).toLowerCase() === signature.toLowerCase();
    }
}